module.exports = __webpack_public_path__ + "img/banner-princiapal.5450eb15.png";